import React from 'react';

type CarouselItemElement = React.ElementRef<'div'>;
type CarouselItemProps = React.ComponentPropsWithoutRef<'div'>;

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const CarouselItem = React.forwardRef<
  CarouselItemElement,
  CarouselItemProps
>((props, forwardedRef) => {
  return <div {...props} ref={forwardedRef} />;
});

CarouselItem.displayName = 'CarouselItem';
